function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.1027 1.07489C14.6729 -0.358293 16.6149 -0.358297 17.185 1.07488L20.1088 8.42403C20.3492 9.02822 20.8927 9.44104 21.5166 9.49334L29.1057 10.1294C30.5857 10.2534 31.1858 12.1843 30.0582 13.1941L24.2761 18.3722C23.8008 18.7979 23.5932 19.4659 23.7384 20.1024L25.5049 27.8447C25.8494 29.3545 24.2783 30.5478 23.0112 29.7388L16.5139 25.5898C15.9798 25.2488 15.308 25.2488 14.7738 25.5898L8.27647 29.7388C7.00941 30.5478 5.4383 29.3545 5.7828 27.8447L7.54932 20.1024C7.69455 19.4659 7.48695 18.7979 7.0116 18.3722L1.2295 13.1941C0.101919 12.1843 0.702025 10.2534 2.182 10.1294L9.7711 9.49334C10.395 9.44104 10.9385 9.02822 11.1789 8.42403L14.1027 1.07489Z",
  fill: "#FF9B05"
});

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.0a87df49.svg";
export { ForwardRef as ReactComponent };